<div class="container-fluid ">
    
    <mat-divider class="mb-4"></mat-divider>
    
    <form [formGroup]="resumenForm" class="row">
        <div class="row">
            <h3>Total de Activos</h3>
            <label class="h4">{{totalActivos | currency:'CLP':'symbol':'1.0-0'}}</label>
        </div>
        <div class="row">
            <h3>Total de Pasivos</h3>
            <label class="h4">{{totalPasivos | currency:'CLP':'symbol':'1.0-0'}}</label>
        </div>
        <div class="row borde">
            <div class="col-1 ar" style="width: 100%;">
                <mat-checkbox formControlName="firmaEstado"> </mat-checkbox>
                Comprendo que, al presionar 'Firmar Estado de Situación', este será enviado a la Banca y no podrá ser modificado posteriormente.            </div>
        </div>
        <div class="row">
            <div class="mt-4">
                <button id="firmarBtn" [disabled]="formFirmado" mat-raised-button color="primary" type="submit" class="ml1 mr1 fr" (click)="onSubmit()">Firmar Estado Situación</button>
                <button id="firmarVolver" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="volver()">Volver</button>
                <button id="GuardarBorrador" type="button" mat-raised-button color="secundary" class="ml1 mr1 fr" (click)="toHome()">Guardar Borrador</button>
            </div>
          </div>

    </form>

</div>
